import { Avatar } from '@mui/material'

import { IMediaConnection } from 'src/types'
import { useStyles } from '../styles'

interface IProps {
  connection: IMediaConnection | null
}

export const ConnectionCell = ({ connection }: IProps) => {
  const classes = useStyles()

  return (
    <div className={classes.iconWrapper}>
      {connection?.image && (
        <Avatar
          src={connection.image_small || connection.image}
          alt={connection.title}
          variant="circular"
        />
      )}
      <div className={classes.connectionText}>
        <strong>{connection?.title || '-'}</strong>
        <span className={classes.connectionSubtitle}>{connection?.type.replace('_', ' ')}</span>
      </div>
    </div>
  )
}
